module.exports = __webpack_public_path__ + "assets/img/timesheet.a4606967.svg";